export default {
  terms:
    'Ao fazer o seu pedido, concorda com os nossos <TermsLink>Termos e Condições</TermsLink> e com a nossa <PrivacyPolicyLink>Política de Privacidade</PrivacyPolicyLink>.',
};
